"use strict";

var snakeCase = require('lodash/snakeCase');

var RibbonSpool = require('../../products/components/RibbonSpool');

var numSpools = require('../PrintingDetails/componentComposables/numSpools/numSpools');

var Inventory = require('./Inventory');

function inventoryRibbonSpools(comps, date, options) {
  var spools = comps.filter(function (comp) {
    return Object.prototype.isPrototypeOf.call(RibbonSpool.prototype, comp);
  });
  var inventory = {};
  spools.forEach(function (comp) {
    var color = comp.ribbon_spool_color.replace(' Ribbon', '');

    if (color === 'None') {
      return;
    }

    if (inventory[color]) {
      inventory[color] += comp.quantity;
    } else {
      inventory[color] = comp.quantity;
    }
  });
  var acc_ribbon_components = comps.filter(function (comp) {
    return comp.acc_ribbon;
  });
  acc_ribbon_components.forEach(function (comp) {
    var color = comp.acc_ribbon;

    if (color === 'None') {
      return;
    }

    var componentSettings = options.printers.printingPlus.components;
    var opts = componentSettings[comp.type] || componentSettings["default"];
    var quantity = numSpools(null, null, null, comp, opts);

    if (inventory[color]) {
      inventory[color] += quantity;
    } else {
      inventory[color] = quantity;
    }
  });
  return Object.keys(inventory).map(function (color) {
    var name = "".concat(color, " Ribbon Spools");
    return new Inventory({
      key: snakeCase(name),
      unit: 'each',
      quantity: inventory[color],
      category: 'ribbon_spools',
      name: name,
      date: date
    });
  });
}

module.exports = inventoryRibbonSpools;